<template>
  <v-container>
<!--  v-rowを入れてpadding-leftを無視してJobFormの面を合わせてる。単品なら不要  -->
    <v-row>
      <v-radio-group
              v-model="internalValue"
              :rules="rules"
              @keypress.enter="onSubmit"
              :row="row"
      >
        <v-radio
                v-for="(item, i) in items"
                :key="i"
                :label="item.label"
                :value="item.value"
                :class="itemClass(item)"
        />
      </v-radio-group>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "BoolRadioField",
    props: {
      "value": {
        type: Boolean,
        default: null,
      },
      "name": {
        type: String,
        required: true,
      },
      "row": Boolean,
      "items": {
        type: Array,
        default: () => [
          {label: "True", value: true},
          {label: "False", value: false},
        ]
      },
      "required": Boolean,
      "submit": Function,
      highlight: {
        type: [Object, Boolean],
        default: null
      }
    },
    data() {
      return {
        internalValue: this.value,
      }
    },
    computed: {
      rules () {
        return [
          value => {
            if (this.required) {
              if (value === false) {
                return true;
              }
              return !!value || this.error("required", [this.name]);
            }
            return true;
          }
        ]
      }
    },
    methods: {
      onSubmit () {
        if (this.submit) {
          this.submit()
        }
      },
      itemClass(item) {
        if (item.value === this.highlight) {
          return ["highlight"]
        }
      },
    },
    components: {},
    watch: {
      value(newVal) {
        this.internalValue = newVal;
      },
      internalValue(newVal) {
        this.$emit('input', newVal);
      }
    },
  }
</script>

<style scoped>
div.v-radio.highlight {
  background-color: rgba(122, 171, 204, 0.2);
}
</style>
